/**
 * UI state reducer
 * Manages UI-related state (modals, dropdowns, calendars)
 */

export const uiReducer = (state, action) => {
  switch (action.type) {
    // Modals
    case 'SET_INVOICE_TYPE_MODAL_OPEN':
      return { ...state, invoiceTypeModalIsOpen: action.payload };
    
    case 'SET_USER_SELECT_MODAL':
      return { ...state, userSelectModal: action.payload };
    
    case 'SET_IS_AUTOMATIC_INV':
      return { ...state, isAutomaticInv: action.payload };
    
    case 'SET_SHOW_FILTER_MODAL':
      return { ...state, showFilterModal: action.payload };
    
    case 'SET_SHOW_CONFIRMATION_MODAL':
      return { ...state, showConfirmationModal: action.payload };
    
    // Team dropdowns
    case 'SET_TEAM_DROPDOWN_OPEN':
      return { ...state, isTeamDropdownOpen: action.payload };
    
    case 'SET_TEAM_MODAL_DROPDOWN_OPEN':
      return { ...state, isTeamModalDropdownOpen: action.payload };
    
    // Status dropdowns
    case 'SET_STATUS_DROPDOWN_OPEN':
      return { ...state, isStatusDropdownOpen: action.payload };
    
    case 'SET_STATUS_MODAL_DROPDOWN_OPEN':
      return { ...state, isStatusModalDropdownOpen: action.payload };
    
    // Payment status dropdowns
    case 'SET_PAYMENT_STATUS_DROPDOWN_OPEN':
      return { ...state, isPaymentStatusDropdownOpen: action.payload };
    
    case 'SET_PAYMENT_STATUS_MODAL_DROPDOWN_OPEN':
      return { ...state, isPaymentStatusModalDropdownOpen: action.payload };
    
    // Invoice type dropdowns
    case 'SET_INV_TYPE_DROPDOWN_OPEN':
      return { ...state, isInvTypeDropdownOpen: action.payload };
    
    case 'SET_INV_TYPE_MODAL_DROPDOWN_OPEN':
      return { ...state, isInvTypeModalDropdownOpen: action.payload };
    
    // Calendar
    case 'SET_SHOW_CALENDAR':
      return { ...state, showCalendar: action.payload };
    
    case 'SET_SHOW_MODAL_CALENDAR':
      return { ...state, showModalCalendar: action.payload };
    
    // Showing dropdown
    case 'SET_SHOWING_DROPDOWN_OPEN':
      return { ...state, showingDropdownOpen: action.payload };
    
    // Toggle helpers
    case 'TOGGLE_TEAM_DROPDOWN':
      return { ...state, isTeamDropdownOpen: !state.isTeamDropdownOpen };
    
    case 'TOGGLE_TEAM_MODAL_DROPDOWN':
      return { ...state, isTeamModalDropdownOpen: !state.isTeamModalDropdownOpen };
    
    case 'TOGGLE_STATUS_DROPDOWN':
      return { ...state, isStatusDropdownOpen: !state.isStatusDropdownOpen };
    
    case 'TOGGLE_STATUS_MODAL_DROPDOWN':
      return { ...state, isStatusModalDropdownOpen: !state.isStatusModalDropdownOpen };
    
    case 'TOGGLE_PAYMENT_STATUS_DROPDOWN':
      return { ...state, isPaymentStatusDropdownOpen: !state.isPaymentStatusDropdownOpen };
    
    case 'TOGGLE_PAYMENT_STATUS_MODAL_DROPDOWN':
      return { ...state, isPaymentStatusModalDropdownOpen: !state.isPaymentStatusModalDropdownOpen };
    
    case 'TOGGLE_INV_TYPE_DROPDOWN':
      return { ...state, isInvTypeDropdownOpen: !state.isInvTypeDropdownOpen };
    
    case 'TOGGLE_INV_TYPE_MODAL_DROPDOWN':
      return { ...state, isInvTypeModalDropdownOpen: !state.isInvTypeModalDropdownOpen };
    
    case 'TOGGLE_CALENDAR':
      return { ...state, showCalendar: !state.showCalendar };
    
    case 'TOGGLE_MODAL_CALENDAR':
      return { ...state, showModalCalendar: !state.showModalCalendar };
    
    case 'TOGGLE_SHOWING_DROPDOWN':
      return { ...state, showingDropdownOpen: !state.showingDropdownOpen };
    
    case 'TOGGLE_FILTER_MODAL':
      return { ...state, showFilterModal: !state.showFilterModal };
    
    default:
      return state;
  }
};

export const initialUIState = {
  // Modals
  invoiceTypeModalIsOpen: false,
  userSelectModal: false,
  isAutomaticInv: false,
  showFilterModal: false,
  showConfirmationModal: false,
  // Team dropdowns
  isTeamDropdownOpen: false,
  isTeamModalDropdownOpen: false,
  // Status dropdowns
  isStatusDropdownOpen: false,
  isStatusModalDropdownOpen: false,
  // Payment status dropdowns
  isPaymentStatusDropdownOpen: false,
  isPaymentStatusModalDropdownOpen: false,
  // Invoice type dropdowns
  isInvTypeDropdownOpen: false,
  isInvTypeModalDropdownOpen: false,
  // Calendar
  showCalendar: false,
  showModalCalendar: false,
  // Showing dropdown
  showingDropdownOpen: false,
};

